import { registerRootComponent } from 'expo';
import App from './App';

// Este archivo es el punto de entrada de tu aplicación
// Asegúrate de que App esté correctamente configurado para manejar la navegación
registerRootComponent(App);
